import Nullstack from 'nullstack';
export default function IconBuildingEstate({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-building-estate",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 21h18"
  }), "   ", Nullstack.element("path", {
    d: "M19 21v-4"
  }), "   ", Nullstack.element("path", {
    d: "M19 17a2 2 0 0 0 2 -2v-2a2 2 0 1 0 -4 0v2a2 2 0 0 0 2 2z"
  }), "   ", Nullstack.element("path", {
    d: "M14 21v-14a3 3 0 0 0 -3 -3h-4a3 3 0 0 0 -3 3v14"
  }), "   ", Nullstack.element("path", {
    d: "M9 17v4"
  }), "   ", Nullstack.element("path", {
    d: "M8 13h2"
  }), "   ", Nullstack.element("path", {
    d: "M8 9h2"
  }), " ");
}